class ProductSwitch extends HTMLElement {
  productForm = this.querySelector('product-form') || null;
  quickShopLightbox = this.closest('quick-shop-lightbox') || null;
  label = this.querySelector('[data-product-switch="title"]');

  connectedCallback() {
    this.originalTitle = this.label.textContent || '';
    this.buttons = this.querySelectorAll('[data-switch-product]');
    this.buttons.forEach((button) => {
      button.addEventListener('click', (event) => this.switchProduct(event));
      button.addEventListener('mouseover', (event) => {
        this.label.textContent = event.currentTarget.getAttribute('title');
      });
      button.addEventListener('mouseout', () => {
        this.label.textContent = this.originalTitle;
      });
    });
  }
}

customElements.define('product-switch', ProductSwitch);
